import { Dispatch, SetStateAction } from 'react'
import { Button } from 'primereact/button'
import styled from 'styled-components'
import moment from 'moment'
import i18next from 'i18next'

// local imports
import DateUtil from 'utils/DateUtil'

interface WeekSliderProps {
  availableDateRange: { start: number; end: number }
  tableWeek: { start: Date; end: Date }
  setTableWeek: Dispatch<SetStateAction<{ start: Date; end: Date }>>
}

export default function WeekSlider({ availableDateRange, tableWeek, setTableWeek }: WeekSliderProps) {
  moment.locale(i18next.language)

  const nextSlide = () =>
    setTableWeek((prev) => ({
      start: moment(prev.start).add(1, 'week').toDate(),
      end: moment(prev.end).add(1, 'week').toDate(),
    }))

  const prevSlide = () =>
    setTableWeek((prev) => ({
      start: moment(prev.start).subtract(1, 'week').toDate(),
      end: moment(prev.end).subtract(1, 'week').toDate(),
    }))

  // variables - local states
  const weekStartLabel = moment(tableWeek.start).format('Do MMMM')
  const weekEndLabel = moment(tableWeek.end).format('Do MMMM')

  /* Disable Prev - Next Buttons */
  const tableWeekNumber = moment(tableWeek.start).isoWeek()
  const prevDates = DateUtil.getPastDate(availableDateRange.start)
  const prevWeekNum = moment(prevDates).isoWeek()
  const nextDates = DateUtil.getFutureDate(availableDateRange.end)
  const nextWeekNum = moment(nextDates).isoWeek()
  /* ----------- */
  const disableNext = tableWeekNumber >= nextWeekNum
  const disablePrev = tableWeekNumber <= prevWeekNum

  return (
    <Wrapper>
      <div className="slider-left-arrow">
        <Button
          id="sliderPrev"
          disabled={disablePrev}
          onClick={prevSlide}
          icon="pi pi-chevron-left"
          className="p-button-plain p-button-rounded p-button-text"
        />
      </div>

      <Content>
        {weekStartLabel} - {weekEndLabel}
      </Content>

      <div className="slider-right-arrow">
        <Button
          id="sliderNext"
          disabled={disableNext}
          onClick={nextSlide}
          icon="pi pi-chevron-right"
          className="p-button-plain p-button-rounded p-button-text"
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 8px;
`
const Content = styled.div`
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  min-width: 250px;
  text-align: center;
`
